import pipe from 'ramda/es/pipe';
import toLower from 'ramda/es/toLower';
import toUpper from 'ramda/es/toUpper';
import map from 'ramda/es/map';
import join from 'ramda/es/join';
import split from 'ramda/es/split';

import { capitalize, isEmptyStringOrNull } from '@sironamedical/common';

export * from '@sironamedical/common/utils/string';

export const snakeToPascal = (str: string): string =>
  pipe(toLower, split('_'), map(capitalize), join(''))(str);

export const pascalToCapitalSnake = (str: string): string =>
  pipe(split(/(?=[A-Z])/), join('_'), toUpper)(str);

/**
 * Formats a SCREAMING_SNAKE_CASE status into sentence case.
 * Preserves a trailing "(D)" suffix as-is.
 * e.g. "NOT_STARTED" → "Not started", "PRELIMINARY(D)" → "Preliminary (D)"
 */
export const formatSentenceCase = (value: string): string => {
  const hasSuffix = value.endsWith('(D)');
  const base = hasSuffix ? value.slice(0, -3) : value;
  return capitalize(base.replace(/_/g, ' ')) + (hasSuffix ? ' (D)' : '');
};

export const getStringValueOrNA = (str: Nullable<string>) => {
  if (isEmptyStringOrNull(str)) {
    return 'N/A';
  }

  return str as string;
};

export const formatCamelCase = (str: string) => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (char) => char.toUpperCase());
};
